import {useMeQuery} from '@hooks/useMeQuery';
import {UserRolesEnum} from '@services/user/user.model';

export const useIsAdmin = () => {
    const {
        query: {data: user},
    } = useMeQuery();

    if (!user) {
        return false;
    }

    return (
        user.roles.includes(UserRolesEnum.ADMIN) ||
        user.roles.includes(UserRolesEnum.SUPER_ADMIN)
    );
};
